// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // url: {
  //   production: 'https://api-sidumas.badungkab.go.id/api/',
  //   demo: 'https://demo-apisidumas.badungkab.go.id/api/',
  //   // demo: 'https://demo-sidumas.badungkab.go.id/api/',
  //   local: 'http://127.0.0.1:8000/api/',
  // },
  live: {
    api_url: 'https://demo-apisidumas.badungkab.go.id/api/',
    base_url: 'https://demo-apisidumas.badungkab.go.id',
    admin_url: 'https://demo-adminsidumas.badungkab.go.id',
  },
  // live : {
  //   api_url : "https://api-sidumas.badungkab.go.id/api/",
  //   base_url : "https://api-sidumas.badungkab.go.id",
  //   admin_url : "https://admin-sidumas.badungkab.go.id"
  // },
  demo: {
    api_url: 'https://demo-apisidumas.badungkab.go.id/api/',
    base_url: 'https://demo-apisidumas.badungkab.go.id',
    admin_url: 'https://demo-adminsidumas.badungkab.go.id',
  },
  local: {
    api_url: 'http://127.0.0.1:8000/api/',
    base_url: 'http://127.0.0.1',
    admin_url: 'http://127.0.0.1',
  },
  redirect: {
    oldDomain: 'demo-sidumas.badungkab.go.id',
    newDomain: 'https://demo-kontakbupati.badungkab.go.id',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
